import type { ShoppingList } from '../../lib/api'

/**
 * Coche ou décoche un article, dans la liste telle qu'elle est affichée.
 *
 * Pure, et c'est ce qui permet de l'appliquer <b>avant</b> la réponse du serveur : l'écran bouge
 * à l'instant du geste, la requête suit, et l'ancienne liste est remise si elle échoue.
 *
 * Sans cela, cocher un article demandait deux allers-retours — l'enregistrement, puis le
 * rechargement de la liste — avant que la case ne change. Le serveur répond en 8 ms, mais
 * depuis La Réunion le trajet jusqu'à lui en coûte deux cents : c'est ce temps mort qu'on
 * ressentait, pas une lenteur de calcul.
 */
export function basculerLaCase(liste: ShoppingList, ligneId: string): ShoppingList {
  const danslesRestants = liste.remaining.find((ligne) => ligne.id === ligneId)
  const dansLePanier = liste.inBasket.find((ligne) => ligne.id === ligneId)
  const ligne = danslesRestants ?? dansLePanier

  if (!ligne) {
    return liste
  }

  if (danslesRestants) {
    return {
      remaining: liste.remaining.filter((autre) => autre.id !== ligneId),
      // En fin de panier : c'est le dernier geste, et le voir arriver là confirme qu'il a été
      // pris en compte.
      inBasket: [...liste.inBasket, { ...ligne, isChecked: true }],
    }
  }

  return {
    remaining: [...liste.remaining, { ...ligne, isChecked: false }],
    inBasket: liste.inBasket.filter((autre) => autre.id !== ligneId),
  }
}
